module.exports = __webpack_public_path__ + "img/firecontrol.f5fd3c56.png";